import script from "./ModelHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelHistory.vue?vue&type=script&setup=true&lang=js"

import "./ModelHistory.vue?vue&type=style&index=0&id=319b7e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319b7e48"]])

export default __exports__